import { render } from "./Footer-Large.vue?vue&type=template&id=2725b809&scoped=true&lang=html"
import script from "./Footer-Large.vue?vue&type=script&lang=js"
export * from "./Footer-Large.vue?vue&type=script&lang=js"

import "./Footer-Large.vue?vue&type=style&index=0&id=2725b809&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2725b809"]])

export default __exports__